import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/monar.png'


const _hoisted_1 = /*#__PURE__*/_createTextVNode(" こんにちは。 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 楽しく生きてます。 ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: _ctx.$style.container
  }, [
    _createVNode("div", {
      class: _ctx.$style.me
    }, [
      _createVNode("img", {
        src: _imports_0,
        class: _ctx.$style.icon
      }, null, 2),
      _createVNode("p", {
        class: _ctx.$style.name
      }, "Koh Sakano", 2)
    ], 2),
    _createVNode("p", {
      class: _ctx.$style.introduce
    }, [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ], 2)
  ], 2))
}